export const APP_ROUTES = {
  Home: "/",
  AUTH: "/auth",
  FORGOT_PASSWORD: "/auth/forgot-password",
  REGISTER: "/auth/signup",
  MY_TRADES: "/my-trades",
  PROFILE: "/profile",
  PERSONAL: "/profile/personal",
  WITHDRAW: "/withdraw",
  DEPOSIT: "/deposit",
  LOGIN: "/auth/login",
  SETTINGS: "/setting",
  LANGUAGE: "/setting/language",
  VERIFICATION: "/verification",
  SUPPORT: "/support",
  TRANSACTIONS: "/transactions",
  WITHDRAW_PASSWORD: "/withdraw-password",
  UPDATE_ACCOUNT: "/update-account",
  UPDATE_PASSWORD: "/update-password",
};

export const TABS = {
  Home: "/",
  MY_TRADES: "my-trades",
  PROFILE: "profile",
};

export enum ACCOUNT_TYPE {
  BANK = "BANK",
  CRYPTO = "CRYPTO",
}
